import React from "react";
import DirectoryMenu from "./DirectoryMenu";
import FieldMenu from "./FieldMenu";
import CycleButtonBox from "./CycleButtonBox";
import PropTypes from "prop-types";
import MenuLink from "./MenuLink";
import DomainButton from "./DomainButton";

/*  MenuBox is basically the main controls for the app. Every button in
 *  the leaves of the  MenuBox tree change one piece of the image path string
 *  in main
 */
export default class MenuBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  componentDidMount() {
    this.createSwitchboard();
  }

  // the switchboard allows us to control that one field
  // menu can be open at a time
  createSwitchboard = () => {
    const menuSwitchboard = new Map();
    Object.keys(this.props.data["fields"]).forEach(
      (fieldname) => {
        menuSwitchboard.set(fieldname, false);
      }
    );

    this.setState({ menuSwitchboard })
  }
  // dates can be open or closed when a field menu
  // is open or closed
   handleDirMenuToggle = () => {
    this.setState({ open: !this.state.open });
  }

  // when a closed field menu is clicked,
  handleFieldMenuToggle = (field) => {
    let changed = this.state.menuSwitchboard;
    // if a closed menu has been clicked before
    if(this.state.closeMeNext) {
      // and this field menu is not the same as the previous one
      if(this.state.closeMeNext !== field) {
        // flip the switch on the previous one (close it)
        changed.set(this.state.closeMeNext, false);
      }
    }
    // now flip the switch of the field of the one we want
    // so if closeMeNext === field, we will close it
    const on = this.state.menuSwitchboard.get(field);
    changed.set(field, !on);
    // update the state with the change and note this field should be closed next
    this.setState({ menuSwitchboard : changed, closeMeNext : field })
  }

  render() {
    const { open } = this.state;
    const data = this.props.data;
    const cycles = Object.keys(this.props.data["cycles"]);

    if(!this.state.menuSwitchboard) {
      return <div/>
    } else {
        return (
          <div className="menu-box">
              <div className="selected-dir">
                <h4 className="date-label">Current date:</h4>
                <p>{this.props.selectedDir}</p>
              </div>
              <DirectoryMenu title="Forecast Directories"
                dirs={this.props.dirs}
                onEvent={this.props.handleDirChange}
                handleMenuToggle={this.handleDirMenuToggle}
                open={open}
              />
              <CycleButtonBox
                classname="cycles"
                onEvent={this.props.handleCycleChange}
                cycles={cycles}
                handleMenuToggle={this.handleMenuToggle}
                open={open}
              />
              {Object.keys(this.props.data["fields"]).map(( m, i ) => (
                  <FieldMenu
                      key={i}
                      title={m}
                      menuData={Object.keys(data["fields"][m]) ? data["fields"][m] : null}
                      onEvent={this.props.handleFieldChange}
                      handleMenuToggle={this.handleFieldMenuToggle}
                      open={this.state.menuSwitchboard.get(m)}
                   />
                )
              )}
          </div>
      );
    }
}
}

MenuBox.propTypes = {
  // data is from a json file structured specifically to populate
  // wof-essential menus. cycles, units, and fields are all included in the json
  // the menus will not display without this information
  data: PropTypes.object.isrequired,
  // dates is an array that populates the date menu. it's the list of directories
  // where the images are located
  dates: PropTypes.arrayOf(PropTypes.string),
  // the date we need to display because it is the directory we pointing to right now
  selectedDate: PropTypes.string,
  // the handle funcs take date, cycle, and fields as args and Main state updates
  // as does the path name for the image product
  handleDateChange: PropTypes.func.isRequired,
  handleCycleChange: PropTypes.func.isRequired,
  handleFieldChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/MenuBox.js